import { useEffect,useState } from "react";
import { Card } from "antd";
import { useNavigate,  useLocation } from "react-router-dom";
import InterviewDayScheduleCard from "../interviewDayScheduleCard";
import "./interviewDaySchedule.scss";

export default function InterviewDaySchedule({jd,sDate,product="qhrflow"}) {
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const parentPath = pathSegments[1];


  useEffect(() => {
    //getAllJds();
  }, []);

  const tabList = [
    {
      key: 'tab1',
      tab: 'Candidates',
    },
    {
      key: 'tab2',
      tab: 'Panels',
    },
    {
      key: 'tab3',
      tab: 'Reminders',
    },
    {
      key: 'tab4',
      tab: 'HR Contacts',
    },
  ];

  const contentList = {
    tab1: <InterviewDayScheduleCard  
             role={'candidates'}
             jd={jd}
             sDate = {sDate}
          /> ,
    tab2: <InterviewDayScheduleCard  
             role={"panel"}
             jd={jd}  
             sDate = {sDate}           
           />,
    tab3: <InterviewDayScheduleCard  
           role={"reminders"}
           jd={jd}
           sDate = {sDate}
         />,
    tab4: <InterviewDayScheduleCard  
         role={"contact"}
         jd={jd}
         sDate = {sDate}
       />                     
  };

  const [activeTabKey1, setActiveTabKey1] = useState('tab1');
  const onTab1Change = (key) => {
    setActiveTabKey1(key);
  };

  const getTitle = () => {
    return  jd.client+ "- ["+ jd.qhcompanyjid+ "]   "+jd.title 
  };
  
  return (
    <div className="interviewDaySchedule-wrapper">
      <Card
        title= {getTitle()}
        tabList={tabList}
        activeTabKey={activeTabKey1}
        onTabChange={onTab1Change}
        onClick={() => {
          navigate(`/${parentPath}/${jd.qhcompanyjid}`);
        }}
        style={{ cursor: "pointer" }}
      >
        <div onClick={(e) => e.stopPropagation()}>
        {contentList[activeTabKey1]}
        </div>
      </Card>
    </div>
  );
}
